import { api } from '../core';
import { CASES_BASIC_TAG } from '../constants';
import { setCasesBasicList } from '@/store';

export interface CasesBasicItem {
  caseId: string;
  caseReference: string;
}

export type CasesBasicResponse = CasesBasicItem[];

type CasesBasicProps = object;

const casesBasicApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCasesBasic: builder.query<CasesBasicResponse, CasesBasicProps>({
      query: (/* params: CasesBasicProps */) => {
        return {
          url: `cases/basic`,
          method: 'GET'
        };
      },
      providesTags: () => [{ type: CASES_BASIC_TAG }],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          if (data) {
            dispatch(setCasesBasicList(data));
          }
        } catch (error) {
          console.error('Error in getCasesBasic in onQueryStarted:', error);
        }
      },
      extraOptions: { maxRetries: 3 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyGetCasesBasicQuery } = casesBasicApi;
